import React, { useEffect, useState } from "react";
import { Button } from "antd";
import { LoginOutlined } from "@ant-design/icons";
import { Link, Outlet } from "react-router-dom";
import "./homeLanding.css";
const Homepage = () => {
  const [activeNav, setActiveNav] = useState(window.location.hash || "#features");
  useEffect(() => {
    const syncHash = () =>
      setActiveNav(window.location.hash || "#features");
    window.addEventListener("hashchange", syncHash);
    return () => window.removeEventListener("hashchange", syncHash);
  }, []);
  return (
    <div className="chat-public-shell">
      <header className="chat-public-nav product-nav">
        <Link className="chat-public-brand product-logo" to="/home_item1">
          <b>C</b>
          <span>
            <strong>ChatTool</strong>
            <small>聊天助手 · 智能话术工作台</small>
          </span>
        </Link>
        <nav className="chat-desktop-nav">
          <a
            className={activeNav === "#features" ? "active" : ""}
            href="/home_item1#features"
            onClick={() => setActiveNav("#features")}
          >
            功能
          </a>
          <a
            className={activeNav === "#workflow" ? "active" : ""}
            href="/home_item1#workflow"
            onClick={() => setActiveNav("#workflow")}
          >
            流程
          </a>
          <a
            className={activeNav === "#download" ? "active" : ""}
            href="/home_item1#download"
            onClick={() => setActiveNav("#download")}
          >
            下载
          </a>
          <Button
            icon={<LoginOutlined />}
            onClick={() => (window.location.href = "/login")}
          >
            管理工作台
          </Button>
        </nav>
      </header>
      <main className="chat-public-content">
        <Outlet />
      </main>
    </div>
  );
};
export default Homepage;
